import React from "react";
import login from "../../Assets/brand/login.svg";

const FirstVerifyIllustration: React.FC = () => {
  return (
    <div className="max-w-md" id="first-verify-illustration-container">
      <img
        src={login}
        alt="First verification illustration"
        className="w-full h-auto"
        id="first-verify-illustration-image"
      />
    </div>
  );
};

export default FirstVerifyIllustration;
